/* eslint-disable vue/no-use-v-if-with-v-for */
<template>
  <div>
    <div :id="maxscrollTop ? 'commonGoTopNav' : ''" class="navBox">
      <div class="commonNavBox">
        <div
          :class="tabOpt == index ? 'tabList tabOpt' : 'tabList'"
          v-for="(item, index) in navList"
          :key="index"
          @click="handleClick(item, index)"
        >
          <div class="text">{{ item.catname }}</div>
        </div>
      </div>
    </div>
    <div class="infomationCenter">
      <div class="info_top" v-if="newsFirst">
        <img :src="$imgUrl.imgUrl(newsFirst.thumb)" alt="" class="articleimg" />
        <div class="infos">
          <div class="title artText textLinesLimit_1">
            {{ newsFirst.title }}
          </div>
          <div class="dec artText textLinesLimit_1">
            {{ newsFirst.description }}
          </div>
          <div class="time artText">{{ newsFirst.time }}</div>
          <div class="articleBtn" @click="getUrl(newsFirst)">
            <div>read more</div>
            <div>
              <img alt />
            </div>
          </div>
        </div>
      </div>
      <div class="info_bottom">
        <div
          class="infoItem"
          v-for="(item, index) in infomationList"
          :key="index"
        >
          <img :src="$imgUrl.imgUrl(item.thumb)" alt="" class="articleimg" />
          <div class="infos">
            <div class="title artText textLinesLimit_1">{{ item.title }}</div>
            <div class="dec artText textLinesLimit_1">{{ item.description }}</div>
            <div class="articleBtn" @click="getUrl(item)">
              <div>read more</div>
              <div>
                <img alt />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="pagination" v-if="last_page">
        <el-pagination background layout="prev, pager, next" :total="total" :page-size='6' @current-change="changPage" >
        </el-pagination>
        Total: {{last_page}} Pages
      </div>
    </div>
  </div>
</template>

<script>
import * as axios from "../../src/axios/api.js";
export default {
  data() {
    return {
      catid:'',
      maxscrollTop: false,
      currentPage:1,
      navList: [
        // { name: "稻喜资讯", path: "infomation" },
        // { name: "行业新闻", path: "news" },
        // { name: "视频中心", path: "videoCenter" },
      ],
      tabOpt: 0,
      infomationList: [
        
      ],
      newsFirst:{},
      total:0,
	  last_page:0,
    };
  },
  created() {
    let id = this.$route.query.id;
    this.getInfomationList(id);
    this.catid=id
  },
  methods: {
    getInfomationList(catid) {
      var page=this.currentPage
      axios.get("/api/news",{catid:catid,page:page}).then((res) => {
        if (res.code == 1) {
          this.navList=res.data.category;
          this.infomationList=res.data.list.data;
          this.newsFirst=res.data.top;
		  this.last_page=res.data.list.last_page
          this.total=res.data.list.total
        }
      });
    },
    changPage(val){
      this.currentPage=val;
      this.getInfomationList(this.catid);
    },
    getUrl(item){
      this.$router.push({ name: "newListDetail", query: {id:item.id,catid:item.catid,type:1}});
    },
    handleClick(item, index) {
      // var index = tab.index
      var that = this;
      that.tabOpt = index;
      var name= item.url.replace("/","");
      this.$router.push({ name: name, query: {id:item.id} });
      //   this.$router.push({ name: "productDetail", query: {} });
    },
    handleScroll() {
      var scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      if (scrollTop > 58) {
        this.maxscrollTop = true;
      } else {
        this.maxscrollTop = false;
      }
    },
    linkUrl(url) {
      window.location.href = url;
    },
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
  },
};
</script>

<style  scoped>
.navBox {
  padding: 0 12%;
  box-sizing: border-box;
  justify-content: flex-start;
}
.infomationCenter {
  /* padding: 0 260px; */
  box-sizing: border-box;
  width: 72%;
  margin: 0 auto;
}
.info_top {
  height: 510px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  border-bottom: 1px solid #F1F1F1;
  margin-bottom: 60px;
}
.info_top .articleimg {
  width: 700px;
  height: 420px;
  background: #f4f7f2;
  margin: 30px 45px 60px 0;
  box-sizing: border-box;
}
.info_top .infos {
  width: 100%;
  height: 100%;
  padding: 78px 0 0 0;
  box-sizing: border-box;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  flex-direction: column;
  position: relative;
}
.artText {
  font-weight: 400;
  line-height: 42px;
}
.info_top .title {
  font-size: 26px;
  color: #333333;
}
.info_top .dec {
  font-size: 18px;
  color: #666666;
}
.info_top .time {
  font-size: 14px;
}
.info_top .articleBtn {
  margin-top: 55px;
}

.info_bottom {
  /* width: 100%; */
  display: flex;
  /* justify-content: space-between; */
  align-items: flex-start;
  flex-wrap: wrap;
  margin:0 -10px;
}
.info_bottom .infos {
  width: 100%;
}
.info_bottom .infos .title {
  font-size: 18px;
  color: #333333;
}
.info_bottom .infos .dec {
  font-size: 14px;
  color: #666666;
}
.infoItem {
  width: 32%;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  flex-direction: column;
  margin: 0 0.66%;
  margin-bottom: 48px;
}
.infoItem .articleimg {
  width: 100%;
  height: 332px;
  background: #f7f7f7;
  flex-shrink: 0;
}
.info_bottom .dec {
  line-height: 24px;
  margin-bottom: 20px;
}

.info_top .title:hover {
  color: #009144;
}
.info_top .dec:hover {
  color: #009144;
}

.info_top .articleBtn:hover {
  background: #009144;
}
.info_top .articleBtn:hover div {
  font-size: 16px;
  color: #fcfcfe;
}
.info_top .articleBtn:hover img {
  width: 21px;
  height: 8px;
  content: url(../../src/img/arrow_white.png);
}

.infoItem .title:hover{
  color: #009144;
}
.infoItem .dec:hover {
  color: #009144;
}

.infoItem .articleBtn:hover {
  background: #009144;
}
.infoItem .articleBtn:hover div {
  font-size: 16px;
  color: #fcfcfe;
}
.infoItem .articleBtn:hover img {
  width: 21px;
  height: 8px;
  content: url(../../src/img/arrow_white.png);
}
.articleBtn {
  /* position: absolute;
  bottom: 16px;
  right: 50px; */
  display: flex;
  justify-content: center;
  align-items: center;
  width: 140px;
  height: 38px;
  padding: 11px 14px;
  box-sizing: border-box;
  border: 1px solid #cccccc;
}
.articleBtn div {
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #666666;
}
.articleBtn img {
  margin-left: 8px;
  width: 21px;
  height: 8px;
  content: url(../../src/img/arrow_gray.png);
}
/* .articleBtn:hover {
  background: #009144;
}
.articleBtn:hover div {
  font-size: 16px;
  color: #fcfcfe;
}
.articleBtn:hover img {
  width: 21px;
  height: 8px;
  content: url(../../src/img/arrow_white.png);
} */
.pagination {
  margin-top: 48px;
  margin-bottom: 90px;
}

/* /deep/.el-pagination.is-background .btn-next,
/deep/.el-pagination.is-background .btn-prev,
/deep/.el-pagination.is-background .el-pager li {
  width: 40px;
  height: 40px;
  font-size: 14px;
  line-height: 40px;
} */
</style>